import {getScheduleItems, getScheduleItemsTotal} from '../../../selectors/schedule'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {ScheduleOwnProps, ScheduleRuntimeProps} from './interfaces'
import {Schedule as Presentation} from './schedule'

export const mapRuntime = ({state, actions: {navigateToSchedulePage}}: DetailsPageAppProps): ScheduleRuntimeProps => {
  const componentSettings = state.component.settings

  return {
    items: getScheduleItems(state),
    total: getScheduleItemsTotal(state),
    componentSettings,
    navigateToSchedulePage,
  }
}

export const Schedule = connect<ScheduleOwnProps, ScheduleRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
